import React from 'react'

const Nodejs_Coding_Pratice_7 = () => {
  return (
    <div>
      <h1>Coding Pratice 7</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_7
